const SeriesDimension = {
    X: 1,
    Y: 2,
    Z: 3,
};

export default SeriesDimension;